import { events } from "@grindex-common/helpers/events";
import { addListener } from "@grindex-common/helpers/domManipulation";
// ReSharper disable InconsistentNaming
const EVENT_TAB_SWITCH = "tabs:switched";
const EVENT_LAZY_BEFORE_UNVEIL = "lazybeforeunveil";
const EVENT_ORIENTATION_CHANGE = "orientationchange";

const SELECTOR_SLIDER = "ul.bxslider";

const SELECTOR_VIEW = '[xyl-view="carousel"]';
const CLASS_CAROUSEL_COMPONENT = "component-carouselBlock";
const CLASS_MAGNIFICATION_CAROUSEL = "c-imgMagnificationCarousel";

const ID_WAVE_SVG_CLIPPATH = "#stem-svg-clippath";
const ID_WAVE_SVG_CLIPPATH_PATH = "#stem-svg-clippath-path";

const PROP_CAROUSEL_HEIGHT = "--carousel-height";
const DEFAULT_CAROUSEL_HEIGHT_PX = "600px";
// ReSharper restore InconsistentNaming

/**
 * @param {HTMLElement} slider
 * @returns
 */
function getClipPathElement(slider) {
	const module = getModuleElement(slider);

	return module?.querySelector(ID_WAVE_SVG_CLIPPATH);
}

/**
 * @param {HTMLElement} slider
 * @returns
 */
function getClipPathPathElement(slider) {
	const module = getModuleElement(slider);

	return module?.querySelector(ID_WAVE_SVG_CLIPPATH_PATH);
}

/**
 * @param {HTMLElement} slider
 * @returns {HTMLElement | null}
 */
function getModuleElement(slider) {
	return slider.closest(SELECTOR_VIEW);
}

function getUpTime(slider) {
	const module = getModuleElement(slider);
	const upTime = module && module.dataset.pause;
	return upTime ? upTime * 1000 : 5000;
}

/**
 * @param {HTMLElement} slider
 * @returns {HTMLElement | null}
 */
function getCarouselElement(slider) {
	return slider.closest(`.${CLASS_CAROUSEL_COMPONENT}`);
}

/**
 * @param {HTMLElement} slider
 * @param {boolean} isImgMagnification
 * @returns
 */
function shouldAutoSlide(slider, isImgMagnification) {
	let module = getModuleElement(slider);

	let autoSlide = module && module.dataset.autoplay;

	return autoSlide === "true" || autoSlide === "True" ? (isImgMagnification ? false : true) : false;
}

/**
 * @param {HTMLElement} slider
 * @returns
 */
function isImgMagnificationCarousel(slider) {
	return slider.parentElement.classList.contains(CLASS_MAGNIFICATION_CAROUSEL);
}

/**
 * @param {JQuery<HTMLElement>} $slider
 * @returns
 */
function redrawCarousel($slider) {
	if ($slider.offsetParent !== null) {
		$slider.redrawSlider();
	}
}

function lazyLoadImages() {
	document.addEventListener(EVENT_LAZY_BEFORE_UNVEIL, function (e) {
		const bg = e.target.dataset.bg;
		if (bg) {
			e.target.style.backgroundImage = 'url("' + bg + '")';
		}
	});
}

function manageResizeEvent() {
	const resizeEvent = new Event("resize", { bubbles: true, cancelable: false });

	function handleOrentationChange() {
		window.dispatchEvent(resizeEvent);
	}

	window.addEventListener(EVENT_ORIENTATION_CHANGE, handleOrentationChange, {
		capture: false,
	});
}

/**
 * Creates a handler for resizing the new Slider
 * @param {HTMLElement | null} $slider
 * @returns
 */
function createResizeTheWaveHandler($slider) {
	const clipPathElement = getClipPathElement($slider);
	const pathElement = getClipPathPathElement($slider);
	const carouselElement = getCarouselElement($slider);

	return function () {
		if (clipPathElement && pathElement) {
			const carouselHeight = !carouselElement ? DEFAULT_CAROUSEL_HEIGHT_PX : getComputedStyle(carouselElement).getPropertyValue(PROP_CAROUSEL_HEIGHT);

			const height = parseFloat(carouselHeight);
			const width = window.innerWidth;

			const clipPathNormalizedY = 0.0016666667;
			const heightRatio = clipPathNormalizedY * height;

			// Leaf SVG Path data, we make the svg as wide as the window + the wave
			const svgPath = `M387.566 173.755C462.462 72.681 524.039 0 645 0h${width}v600H0c46.172 0 79.684-21.309 133.728-93.778l105.854-141.229 147.984-191.238Z`;

			pathElement.setAttribute("d", svgPath);

			// // We don't want to distort the SVG Leaf on the X-axis
			// // but we want it to scale to the height of the carousel
			clipPathElement.style.transform = `scale(${heightRatio}, ${heightRatio})`;
		}
	};
}

function initSlider() {
	const $sliders = $(SELECTOR_SLIDER);

	if ($sliders.length === 0) {
		return;
	}

	for (let i = 0; i < $sliders.length; i = i + 1) {
		let $slider = $sliders[i];
		const $jqSlider = $($slider);
		const children = $jqSlider.children("li");

		const waveResizeHandler = createResizeTheWaveHandler($slider);

		// Run the resize in an animation frame to let the browser figure out when it can run it smoothly
		const animationFrameWaveResizeHandler = () => requestAnimationFrame(waveResizeHandler);

		// We need to resize the leaf blade even when not in a slider
		addListener(window, "resize", animationFrameWaveResizeHandler);

		const carouselElement = getCarouselElement($slider);

		if (children.length > 1) {
			const isImgMagnification = isImgMagnificationCarousel($slider);

			const bxSlider = $jqSlider.bxSlider({
				auto: shouldAutoSlide($slider, isImgMagnification),
				pause: getUpTime($slider),
				autoHover: true,
				controls: !isImgMagnification,
				pager: true,
				infiniteLoop: true,
				onSliderLoad: function () {
					$jqSlider.addClass("initialized");
					if (carouselElement) {
						carouselElement.style.visibility = "visible";
					}
				},
			});

			$jqSlider.find(".bx-controls").show();

			document.addEventListener(EVENT_TAB_SWITCH, redrawCarousel(bxSlider));
			document.addEventListener(events.ACCORDION_OPENED, redrawCarousel(bxSlider));
		}

		animationFrameWaveResizeHandler();
		if (carouselElement && children.length <= 1) {
			$jqSlider.addClass("initialized");

			// EXAMPLE: Remove the animation class so that we can animate in the next slide
			// debounce(() => {
			// 	carouselElement.classList.remove(CLASS_SLIDE_ANIMATE);
			// }, 1000)();
		}
	}
}

function init() {
	window.addEventListener("load", initSlider);
	lazyLoadImages();
	manageResizeEvent();
}

export default {
	view: "carousel",
	init,
};
